
import resize from "./resize"
export default {
    mixins: [resize],
    mounted () {
        this.handlerResize(() => {
            if (Object.isObj(this.chart)) {
                this.chart.resize()
            }
        })
    }
}
